import createLogger from './logger';
export default class Reporter {
  constructor(options, reporters) {
    // 上报队列
    this.$queue = [];
    // 是否延迟上报
    this.delay = false;
    this.$reporters = reporters;
    this.delay = options?.delay || false;
    this.logger = createLogger(options?.silent || false);
  }

  /**
   * 设置额外上报参数
   */
  setExtraParams(params) {
    this.runMiddleware((reporter) => {
      reporter.setExtraParams(params);
    });
  }
  /**
   * 上报就绪
   */
  async ready() {
    this.delay = false;
    await this.runMiddleware(async (reporter) => {
      await reporter.ready();
    });
    while (this.$queue.length) {
      const [params, type] = this.$queue.pop();
      this.report(params, type);
    }
  }
  /**
   * 上报
   * @param params 上报参数
   * @param type 上报类型
   */
  report(params, type = 'expose') {
    if (this.delay) {
      this.$queue.push([params, type]);
      return;
    }
    this.logger(type, params);
    this.runMiddleware((reporter) => {
      reporter.report(params, type);
    });
  }
  /**
   * 曝光上报
   * @param params 上报参数
   */
  expose(params) {
    this.report(params, 'expose');
  }
  /**
   * 点击上报
   * @param {Object} params 上报参数
   */
  click(params) {
    this.report(params, 'click');
  }
  /**
   * 执行中间件方法
   * @param fn {function}
   */
  async runMiddleware(fn) {
    if (this.$reporters && Array.isArray(this.$reporters)) {
      for (let i = 0; i < this.$reporters.length; i++) {
        await fn(this.$reporters[i]);
      }
    }
  }
}
/**
 * 创建上报器
 * @param {Object} options 上报配置
 * @param {Array} reporters 上报器
 *
 * @return {Reporter}
 */
export function createReporter(options, reporters) {
  return new Reporter(options, reporters);
}
